
const home = (resolve) =>{require(['components/home/home'], resolve)}; 
const bdmp = (resolve) =>{require(['components/product/bdmp'], resolve)}; 
const bdtt = (resolve) =>{require(['components/product/bdtt'], resolve)}; 
const bdcl = (resolve) =>{require(['components/product/bdcl'], resolve)}; 
const yzzs = (resolve) =>{require(['components/product/yzzs'], resolve)}; 
const companyInfo = (resolve) =>{require(['components/product/companyInfo'], resolve)}; 
const newsList = (resolve) =>{require(['components/product/newsList'], resolve)}; 
const article = (resolve) =>{require(['components/product/article'], resolve)};
const joinUs = (resolve) =>{require(['components/product/joinUs'], resolve)};
const culture = (resolve) =>{require(['components/product/culture'], resolve)};

const childRouter = [
	{
		path:'/',
		name:'home',
		component:home
    },
	{
  		path:'/home',
  		name:'home',
  		component:home
	},
	{
		path:'/bdmp',
  		name:'bdmp',
  		component:bdmp
	},
	{
		path:'/bdtt',
  		name:'bdtt',
  		component:bdtt
	},
	{
		path:'/bdcl',
  		name:'bdcl',
  		component:bdcl
	},
	{
		path:'/yzzs',
  		name:'yzzs',
  		component:yzzs
	},
	{
		path:'/companyInfo',
  		name:'companyInfo',
  		component:companyInfo
	},
	{
		path:'/newsList',
  		name:'newsList',
  		component:newsList
	},
	{
		path:'/article/:id',
  		name:'article',
  		component:article
	},
	{
		path:'/joinUs',
  		name:'joinUs',
  		component:joinUs
	},
	{
		path:'/culture',
  		name:'culture',
  		component:culture
	}
]


export default childRouter


// WEBPACK FOOTER //
// ./src/router/routers.js